"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.GridTile = void 0;
const Unit_1 = require("../features/Unit");
const GridUtils_1 = require("../GridUtils");
/**
 * Grid Tile
 */
class GridTile {
    constructor() {
        /**
         * Tile width
         */
        this.width = 0;
        /**
         * Tile height
         */
        this.height = 0;
        /**
         * Zoom level
         */
        this.zoom = 0;
    }
    /**
     * Create a tile
     *
     * @param width
     *            tile width
     * @param height
     *            tile height
     * @param x
     *            x coordinate
     * @param y
     *            y coordinate
     * @param zoom
     *            zoom level
     * @return tile
     */
    static tile(width, height, x, y, zoom) {
        const tile = new GridTile();
        tile.width = width;
        tile.height = height;
        tile.zoom = zoom;
        tile.bounds = GridUtils_1.GridUtils.getBounds(x, y, zoom);
        return tile;
    }
    /**
     * Create a tile
     *
     * @param width
     *            tile width
     * @param height
     *            tile height
     * @param bounds
     *            tile bounds
     * @return tile
     */
    static tileWithBounds(width, height, bounds) {
        const tile = new GridTile();
        tile.width = width;
        tile.height = height;
        tile.bounds = bounds;
        tile.zoom = Math.round(GridUtils_1.GridUtils.getZoomLevel(bounds));
        return tile;
    }
    /**
     * Get the tile width
     *
     * @return tile width
     */
    getWidth() {
        return this.width;
    }
    /**
     * Get the tile height
     *
     * @return tile height
     */
    getHeight() {
        return this.height;
    }
    /**
     * Get the zoom level
     *
     * @return zoom level
     */
    getZoom() {
        return this.zoom;
    }
    /**
     * Get the bounds in the optional units
     *
     * @param unit
     *            units
     * @return bounds in units
     */
    getBounds(unit) {
        let tmpBounds = this.bounds;
        if (unit !== null && unit !== undefined && this.bounds) {
            tmpBounds = this.bounds.toUnit(unit);
        }
        return tmpBounds;
    }
    /**
     * Get the bounds in degrees
     *
     * @return bounds in degrees
     */
    getBoundsDegrees() {
        return this.getBounds(Unit_1.Unit.DEGREE);
    }
    /**
     * Get the bounds in meters
     *
     * @return bounds in meters
     */
    getBoundsMeters() {
        return this.getBounds(Unit_1.Unit.METER);
    }
    /**
     * Get the point pixel location in the tile
     *
     * @param point
     *            point
     * @return pixel
     */
    getPixel(point) {
        return GridUtils_1.GridUtils.getPixel(this.width, this.height, this.bounds, point);
    }
    /**
     * Get the longitude in meters x pixel location in the tile
     *
     * @param longitude
     *            longitude in meters
     * @return x pixel
     */
    getXPixel(longitude) {
        return GridUtils_1.GridUtils.getXPixel(this.width, this.bounds, longitude);
    }
    /**
     * Get the latitude (in meters) y pixel location in the tile
     *
     * @param latitude
     *            latitude in meters
     * @return y pixel
     */
    getYPixel(latitude) {
        return GridUtils_1.GridUtils.getYPixel(this.height, this.bounds, latitude);
    }
}
exports.GridTile = GridTile;
//# sourceMappingURL=GridTile.js.map